/* eslint-disable max-classes-per-file */
/* eslint-disable camelcase */
import { loginService, APIBase } from '@agro1desenvolvimento/apis-js-package';
import { ENV } from '../../utilities/constants';

class LaboratorioAPI extends APIBase {
  constructor() {
    super();

    let baseURL = 'https://homologacao-integrations.aqila.com.br';
    if (ENV === 'production') {
      baseURL = 'https://integrations.aqila.com.br';
    }

    this.initialize({ baseURL });

    this.request.interceptors.request.use((request) => {
      const headers = loginService.requestHeaders();
      delete headers['X-Scope'];
      request.headers = {
        ...headers,
        ...request.headers,
        'X-Scope': 'sementes',
      };
      return request;
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const laboratorioAPI = new LaboratorioAPI();

interface APICidade {
  nome: string;
  uf: string;
  ibge: string;
}

interface APIAnalista {
  id: string;
  nome: string;
  nome_fantasia: string;
  tipo: string;
  cpf_cnpj: string;
  inscricao_estadual: string;
  inscricao_municipal: string;
  telefone: string;
  email: string;
  endereco: string;
  endereco_numero: string;
  endereco_complemento: string;
  endereco_bairro: string;
  endereco_cep: string;
  cidade: APICidade;
  integration_status: number;
  updated_at: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface APIListResponse {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
  data: APIAnalista[];
}

export interface Analista {
  id: string;
  nome: string;
}

function convertAPIToInternal(apiData: APIAnalista): Analista {
  return {
    id: apiData.id,
    nome: apiData.nome,
  };
}

class AnalistasService {
  async list(
    page = 1,
    nome?: string,
    nomeFantasia?: string,
  ): Promise<{ analistas: Analista[]; totalPages: number }> {
    const params: Record<string, any> = { page };

    if (nome) {
      params.nome = nome;
    }

    if (nomeFantasia) {
      params.nome_fantasia = nomeFantasia;
    }

    const response = await laboratorioAPI.get<APIListResponse>(
      '/api/v1/agro1/laboratorio/analistas',
      { params },
    );

    const analistas = response.data.data.map(convertAPIToInternal);

    return {
      analistas,
      totalPages: response.data.total_pages,
    };
  }

  async getById(id: string): Promise<Analista | null> {
    const response = await laboratorioAPI.get<APIListResponse>(
      '/api/v1/agro1/laboratorio/analistas',
      { params: { id } },
    );

    if (!response.data.data || response.data.data.length === 0) {
      return null;
    }

    return convertAPIToInternal(response.data.data[0]);
  }
}

export default new AnalistasService();
